module.exports = "<suite-textarea></suite-textarea>\n"